import { Button } from "@mui/material";
import { GridColDef, GridRenderCellParams, DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { ScenarioNodeDto } from "../Types/types";
import ScenarioNodeDialog from "./ScenarioNodeDialog";
import { createScenariosNodeApi, deleteScenarioNodeApi, getScenariosNodeApi, updateScenarioNodeApi } from "../../../Services/Admin/ScenariosNodeService";

const initialForm: ScenarioNodeDto = {
    id: 0,
    question: "",
    hint: "",
    parentId: 0,
    text: ""
}

const ScenariosNodesList = () => {
    const [rows, setRows] = useState<ScenarioNodeDto[]>([]);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [formCreateData, setFormCreateData] = useState<ScenarioNodeDto>(initialForm);
    const [type, setType] = useState<string>("");

    const handleAddNew = () => {
        setType("Add");
        setFormCreateData(initialForm);
        setDialogOpen(true);
    };

    const handleEdit = (row: any) => {
        console.log(row);
        setType("Edit");
        setFormCreateData(() => ({ ...row }));
        setDialogOpen(true);
    };

    const handleDelete = async (id: number) => {
        const result = await deleteScenarioNodeApi(id);
        if (result) {
            const newRows = rows.filter(x => x.id !== id);
            setRows(newRows)
        }
    };

    const handleChangeCreateForm = (value: any, field: string) => {
        setFormCreateData(prev => ({ ...prev, [field]: value }))
    }

    const handleCloseDialog = () => {
        setDialogOpen(false);
    };

    const handleSave = async () => {
        if (type === "Add") {
            const result = await createScenariosNodeApi(formCreateData);
            console.log("Saved child:", result);
            setRows((prev) => ([result.data, ...prev]));
            setDialogOpen(false);
        }
        else {

            const result = await updateScenarioNodeApi(formCreateData);
            console.log("Saved child:", result);

            const newData = [...rows];
            const index = newData.findIndex(x => x.id === formCreateData.id);
            newData[index] = { ...result.data };

            setRows((prev) => ([...newData]));
            setDialogOpen(false);
        }

    };

    useEffect(() => {
        getScenariosNodeApi().then(res => {
            setRows(res.data);
        });
    }, []);

    const columns: GridColDef[] = [
        { field: "id", headerName: "ID", width: 90 },
        { field: "question", headerName: "question", width: 200 },
        { field: "hint", headerName: "hint", width: 200 },
        { field: "text", headerName: "text", width: 200 },
        { field: "parentId", headerName: "parentId", width: 200 },
        {
            field: "actions",
            headerName: "Actions",
            width: 300,
            renderCell: (params: GridRenderCellParams) => (
                <>
                    <Button
                        variant="contained"
                        onClick={() => handleEdit(params.row)}>
                        Edit
                    </Button>
                    <Button
                        variant="contained"
                        onClick={() => handleDelete(params.row.id)}>
                        Delete
                    </Button>
                </>
            ),
        },
    ];

    return (
        <>
            <h2>Scenarios Node Grid</h2>
            <div style={{ height: 400, width: "100%" }}>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    slots={{
                        toolbar: () => <Button variant="contained" sx={{ width: "10%" }}
                            onClick={() => handleAddNew()}
                        >Add New</Button>
                    }}
                    showToolbar
                />
            </div>
            <ScenarioNodeDialog
                open={dialogOpen}
                formData={formCreateData}
                onChange={handleChangeCreateForm}
                onClose={handleCloseDialog}
                onSave={handleSave}
            />
        </>
    );
};

export default ScenariosNodesList;
